export const environment = {
  production: false,
  envName: 'development',
  apiUrl: '', // use same host for static assets
  useWooCommerce: true,
  wooCommerceUrl: 'https://staging.wasombouw.nl/wp-json/wc/v3',
  wooCommerceKey: 'ck_0f0ee83c0ec3e877b74cb81709aa565285282f82',
  wooCommerceSecret: 'cs_a83d945ef1ae2a85c52cbb8db0dd28b887773448',
  siteUrl: 'https://staging.wasombouw.nl',
  cartUrl: 'https://staging.wasombouw.nl/cart/?add-to-cart=',
  parentOrigin: 'https://staging.wasombouw.nl',
  stagingUser: 'wasombouw2025',
  stagingPassword: 'webmixwasombouw!',
};
